module.exports = __webpack_public_path__ + "static/media/TBA_logo_orange.642f42b3.png";